import { getFirestore } from "firebase/firestore";
import * as firestore from "firebase/firestore";

const db = getFirestore();

export { db, firestore };
